import androidBridge from './bridge/android'
import iOSBridge from './bridge/ios'
import PCbridge from './bridge/PCbridge'

const judgeClient = () => {
  const u = navigator.userAgent
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // 判断是否是 android终端
  const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // 判断是否是 iOS终端
  console.log('是否是Android：' + isAndroid)
  console.log('是否是iOS：' + isIOS)
  if (isAndroid) {
    return 'Android'
  } else if (isIOS) {
    return 'IOS'
  } else {
    return 'PC'
  }
}

const map = {
  Android: androidBridge,
  IOS: iOSBridge,
  PC: PCbridge
}

const bridge = map[judgeClient()];

const track = (data) => {
  if (!bridge) {
    return
  }
  bridge.analyse(data).then(res => {
    //ignore
  }).catch(e => {
    //ignore
  })
}
export { judgeClient, track }
export default bridge
